import styled from 'styled-components';

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 31%);
  flex-wrap: wrap;
  column-gap: 20px;

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 48%);
    padding: 0 10px;
    column-gap: 10px;
    justify-content: space-between;
  }
`;

export const CardTitle = styled.h1`
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 16px 0;
  font-size: clamp(16px, 2vw, 20px);
  text-transform: uppercase;

  @media (max-width: 720px) {
    padding: 16px 10px;
  }
`;

export const CardBox = styled.div`
  outline: 1px solid hsl(0deg, 0%, 0%, 10%);
  border-radius: 4px;
  margin: 16px 0;
  transition: all 0.18s ease-out;
  cursor: pointer;
  position: relative;
  top: 0;

  @media (max-width: 720px) {
    margin: 8px 0;
  }

  &:hover {
    top: -4px;
    box-shadow: 0px 4px 8px #26262624;
    outline: 1px solid #cccccc;

    @media (max-width: 720px) {
      box-shadow: none;
    }
  }
  .transitionClass {
    transition: all 0.2s ease-in-out;
  }
  .gridcardopacity {
    opacity: 0.5;
  }
`;

export const CardBoxContainer = styled.div`
  display: grid;
`;

export const TopicListImage = styled.img`
  width: 100%;
  height: 146px;
  border-radius: 4px 4px 0 0;
  object-fit: cover;

  @media (max-width: 720px) {
    height: 120px;
  }
`;

export const ContentSection = styled.div`
  padding: 8px 12px 16px;

  @media (max-width: 720px) {
    padding: 8px 12px;
  }
`;

export const CardName = styled.h5`
  font-size: clamp(14px, 2vw, 16px);
  font-weight: 500;
  color: rgb(0 0 0 / 87%);
  padding-bottom: 6px;
`;

export const Content = styled.p`
  font-size: 14px;
  color: hsl(0deg, 0%, 0%, 80%);

  @media (max-width: 720px) {
    display: none;
  }
`;

export const ViewAllTopic = styled.div`
  display: flex;
  align-items: center;
  color: #ef4e5e;
  font-weight: 600;
  justify-content: center;
  font-size: clamp(14px, 2vw, 18px);
  height: 100%;
`;
